import { memo } from 'react'

import TopicRefinementButton, { TEST_ID } from './TopicRefinementButton'

const TopicRefinementButtonComponent = memo(TopicRefinementButton)

export { TEST_ID }

export default TopicRefinementButtonComponent
